import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/baloo-2-devanagari-normal-553cb078.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/baloo-2-devanagari-normal-553cb078.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/baloo-2-devanagari-normal-553cb078.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/baloo-2-devanagari-normal-553cb078.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22baloo%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0900-097F,%20U+1CD0-1CF4,%20U+1CF7-1CF9,%20U+200C-200D,%20U+20A8,%20U+20B9,%20U+20F0,%20U+25CC,%20U+A830-A839,%20U+A8E0-A8FF,%20U+11B00-11B0A%22}]}],%22variableName%22:%22balooDevanagari%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'balooDevanagari'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
